"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var SiteHeaderHamburger = function (props) {
    return (React.createElement("div", { className: "hamburger", onClick: function () { return props.toggleMenu(); } },
        React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'bars'] })));
};
exports.default = SiteHeaderHamburger;
